// src/api_scripts/getWorkTypes.js
import { fetchAllPages } from "../paginationUtils";

const getWorkTypes = async (name, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/work-type`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Work Types");
    console.log("Get Work Types API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Work Types:`, error);
    throw error;
  }
};

export default getWorkTypes;